import {expectEither, HttpClient} from '@raison/network-facade';
import {Decoder} from '@raison/prelude';
import {CriticalErrorMsg} from '~/entities/dialogs';
import {Assets, AssetsLax, AssetsLaxToStrict} from '~/shared/api/legacy_services/Assets/Assets';
import {onlyLeading} from '~/shared/utils/for-redux';
import {assetsRequestRoutine} from './assetsActions';

let imagesAlreadyCached = false;

export async function assetsOnlyRequest(
    _: ReturnType<typeof assetsRequestRoutine.trigger>,
    {dispatch, extra: {http}}: AppEffectAPI
) {
    const assets = await fetchAssetsDefault(http).catch(e => {
        assetsRequestRoutine.failure(e);
        dispatch(CriticalErrorMsg.open());
        throw e;
    });

    if (assets.status === 'Abort') {
        return;
    }

    dispatch(assetsRequestRoutine.success(assets.json));

    if (imagesAlreadyCached) {
        return;
    }

    queueMicrotask(() => {
        for (const {icon} of Object.values(assets.json.accounts).flat()) {
            if (icon) new Image().src = icon;
        }
        imagesAlreadyCached = true;
    });
}

export default function (startListening: AppStartListening) {
    startListening({actionCreator: assetsRequestRoutine.trigger, effect: onlyLeading(assetsOnlyRequest)});
}

export async function fetchAssetsDefault(http: HttpClient) {
    return await http('/v1/assets/default').then(
        ...expectEither({
            200: Decoder.makeLax(AssetsLax, Assets, {
                laxToStrict: AssetsLaxToStrict,
                report: false,
            }),
        })
    );
}
